import request from '@/utils/request'


export function login(data) {
  return request({
    url: 'dev-api/pc/login',
    method: 'post',
    data
  })
}

export function getInfo() {
  return request({
    url: 'dev-api/pc/userinfo',
    method: 'get',
  })
}

export function logout() {
  return request({
    url: 'api/home/logout',
    method: 'post'
  })
}